
const ErrorLogQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        // {
        //     name:'log.orderNo', // 订单编号
        //     key:'orderNo',
        //     type:'input',   
        //     allowClear:true,
        //     width:'210px',
        //     placeholder:'base.input',
        // },
        {
            // name:'log.orderName', // 订单名称
            key:'orderName',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'log.orderName',
        },
        {
            // name:'log.sku', // SKU
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'log.sku',
            options:[],
        },
        {
            // name:'log.inventoryCode', // 物料编码
            key:'inventoryCode',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'log.inventoryCode',
            options:[]
        },
        {
            // name:'log.source', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'log.source',
            optionToLocale:true,
            options:[]
        },
        {
            // name:'log.syncType', // 类别
            key:'syncType',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'log.syncType',
            optionToLocale:true,
            options:[
                {
                    label:'SO_CANCEL',
                    value:'SO_CANCEL'
                },
                {
                    label:'SO_CREATE',
                    value:'SO_CREATE'
                },
            ]
        },
        
    ]
}

const RiskLogQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'log.orderNo', // 订单编号
            key:'key_name',
            type:'input',   
            allowClear:true,
            width:'210px',
            placeholder:'log.orderNo',
        },
        
    ]
}


ErrorLogQuery.formField.forEach(item=>{
    ErrorLogQuery.formData[item.key] = ''
})

RiskLogQuery.formField.forEach(item=>{
    RiskLogQuery.formData[item.key] = ''
})


export {
    ErrorLogQuery,
    RiskLogQuery,
}